export enum TOKEN {
  ACCESS_TOKEN = 'accessToken',
  REFRESH_TOKEN = 'refreshToken',
}

export enum USER_ROLE {
  ADMIN = 'Admin',
  USER = 'User',
}
